import { Grid } from "@mui/material";
import VerificationVisitStatus from "./VerificationVisitStatus";
import { SummaryCompleteProps } from "../../app/models/SummaryComplete";
import CompleteVerification from "./CompleteVerification";
import { useState } from "react";
import { useAppSelector } from "../../app/store/configureStore";
import HomeVisitorAssessor from "./homeVisitorAssessor";

export default function VerificationVisitWorksheet() {
  const { user } = useAppSelector((state) => state.account);
  const HomeVisitorSetting = user?.credentialTypeId === 4;
  const description = HomeVisitorSetting
    ? `Complete these steps before you finish putting your portfolio together. Once you have completed these steps, you are ready for “Putting It All Together!”`
    : `Complete this step before you finish putting your portfolio together. Once you have completed this step, you are ready for “Putting It All Together!”`;
  const [summaryCompleteProps] = useState<SummaryCompleteProps>({
    title: "Getting Ready for Your Verification Visit",
    percent: "",
    header: "",
    description: description,
  });

  return (
    <Grid container p={2} mb={2}>
      <VerificationVisitStatus {...summaryCompleteProps} />
      {HomeVisitorSetting && <HomeVisitorAssessor />}
      <CompleteVerification />
    </Grid>
  );
}
